import ContactDuplicate from './../models/ContactDuplicate';
import Base from './Base';

export default class ContactsDuplicate extends Base {
    get models() {
        const collection = this.data.map(item => new ContactDuplicate(item));
        collection.collection = this;

        return collection;
    }
}
